<template>
  <div class="item" @click="toGoodsDetail">
    <img :src="index | sign_f" alt="" class="sign" />
    <div
      class="avatar"
      :style="{
        backgroundImage: 'url(' + data.good.goodsImg + ')',
      }"
    ></div>
    <div class="content">
      <div class="title van-ellipsis">
        {{ data.good.goodsName }}
      </div>
      <div class="tips clearfix">
        <span
          class="van-hairline--surround"
          v-for="(item, index) in data.coupons"
          :key="index"
        >
          {{ item.couponName }}
        </span>
      </div>
      <div class="amount">
        <div class="left distribution" v-distributor="true">
          <span class="prefix">¥</span>
          <span class="value">{{ data.actPrice }}</span>
          <span class="reward">省赚¥</span>
          <span class="reward-value">{{ data.partGoods.saveProfit || 0 }}</span>
        </div>
        <div class="left" v-distributor="false">
          <span class="prefix">¥</span>
          <span class="value">{{ data.actPrice }}</span>
          <span class="unline">¥{{ data.good.linePrice }}</span>
        </div>
        <div class="right">
          <img :src="require('@/assets/activityplace/redcart.svg')" alt="" />
          <div class="share" v-distributor="true" @click.stop="shareClick">
            分享赚钱
            <img :src="require('@/assets/activityplace/分享店铺.svg')" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Toast } from 'vant'
export default {
  props: {
    index: {
      type: Number,
      default: null,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(['distributionFlag']),
  },
  filters: {
    sign_f(val) {
      switch (val) {
        case 0:
          return require('@/assets/activityplace/为你推荐.png')
        case 1:
          return require('@/assets/activityplace/top1.png')
        case 2:
          return require('@/assets/activityplace/top2.png')
        case 3:
          return require('@/assets/activityplace/top3.png')
        case 4:
          return require('@/assets/activityplace/top4.png')
        case 5:
          return require('@/assets/activityplace/top5.png')
        default:
          return ''
      }
    },
  },
  methods: {
    toGoodsDetail() {

      this.$router.push({
        name: 'TopListGoodsDetail',
        params: { id: this.data.partGoodsId },
      })
    },
    shareClick() {
      if (this.data.actState === 'FINISHED') {
        Toast({
          message: '活动已结束',
          position: 'center',
          duration: 1000,
        })
        return
      }
      this.$store.dispatch('shareGoods/show', {
        params: {
          partId: this.data.partId,
          actId: this.data.actId,
          partGoodsId: this.data.partGoodsId,
          goodsId: this.data.goodsId,
        },

        shareOptions: {
          title: this.data.good.goodsName,
          desc: '好货TOP榜',
          imgUrl: this.data.good.goodsImg,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.item {
  position: relative;
  display: flex;
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  padding: 20px 20px 24px;
  .sign {
    position: absolute;
    left: 20px;
    top: -4px;
    width: 60px;
    height: 72px;
  }
  .avatar {
    width: 120px;
    height: 120px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border-radius: 12px;
  }
  .content {
    margin-left: 12px;
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      font-size: 24px;
      font-weight: 600;
      color: #333333;
      line-height: 34px;
      text-align: left;
    }
    .tips {
      padding-top: 8px;
      span {
        float: left;
        display: block;
        font-size: 16px;
        line-height: 1em;
        font-weight: 400;
        color: #e82035;
        padding: 6px 10px;
        & + span {
          margin-left: 8px;
        }
        &::after {
          border-color: #e82035;
          border-radius: 12px;
        }
      }
    }
    .amount {
      display: flex;
      justify-content: space-between;
      padding-top: 6px;
      padding-right: 2px;
      .left {
        display: flex;
        align-items: flex-end;
        .prefix {
          display: block;
          font-size: 24px;
          line-height: 28px;
          font-weight: 800;
          color: #e82035;
        }
        .value {
          display: block;
          font-size: 36px;
          line-height: 36px;
          font-weight: 800;
          color: #e82035;
        }
        .unline {
          font-size: 20px;
          color: #808080;
          line-height: 1em;
          line-height: 28px;
          text-decoration: line-through;
          margin-left: 8px;
        }
        &.distribution {
          .prefix {
            color: #333333;
          }
          .value {
            color: #333333;
          }
          .reward {
            font-size: 20px;
            line-height: 28px;
            color: #e82035;
            font-weight: 600;
            margin-left: 8px;
          }
          .reward-value {
            font-size: 24px;
            font-weight: 600;
            color: #e82035;
            line-height: 28px;
          }
        }
      }
      .right {
        display: flex;
        & > img {
          width: 44px;
          height: 44px;
        }
        .share {
          display: flex;
          margin-left: 20px;
          font-size: 24px;
          font-weight: 400;
          color: #ffffff;
          line-height: 24px;
          padding: 10px 12px;
          background: #e82035;
          border-radius: 44px;
          img {
            width: 24px;
            height: 24px;
            margin-left: 8px;
          }
        }
      }
    }
  }
}
</style>
